import moment from "moment";

export function formatYearRange(isoDate, short = false, isFinancial = false) {
  const m = moment(isoDate);

  if (!isFinancial) {
    const fmt = short ? "YY" : "YYYY";
    const start = m.format(fmt);
    const end = m.clone().add(1, "year").format(fmt);
    return `${start}-${end}`;
  }

  const year = m.year();
  const month = m.month(); // 0-based: 0 = Jan, 3 = Apr

  // Financial year starts in April.
  const startYear = month >= 3 ? year : year - 1;
  const endYear = startYear + 1;

  const formatYear = (y) => {
    const str = String(y);
    return short ? str.slice(-2) : str;
  };

  const start = formatYear(startYear);
  const end = formatYear(endYear);

  return `${start}-${end}`;
}
export default formatYearRange;